module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.wrapClasses
  }, [_c('span', {
    class: _vm.radioClasses
  }, [_c('span', {
    class: _vm.innerClasses
  }), _vm._v(" "), _c('input', {
    class: _vm.inputClasses,
    attrs: {
      "type": "radio",
      "disabled": _vm.disabled,
      "name": _vm.groupName
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm.change,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  })]), _vm._t("default", [_vm._v(_vm._s(_vm.label))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed1d28d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/radio/radio.vue
// module id = 74
// module chunks = 0